import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en";
import pl from "./pl";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  resources: {
    en: {
      translations: en,
    },
    pl: {
      translations: pl,
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "pl"];

export default i18n;
